module.exports = __webpack_public_path__ + "img/EE.318e3c44.svg";